module.exports = __webpack_public_path__ + "img/mobile/SmartButton/btn-quickspin-off-up@1x.png?0.0.53";